import {
  StoreReviewSortSchema,
  type StoreReviewSort as GeneratedStoreReviewSort
} from '~/services/api/generated'

// Mirrors backend App\Enums\StoreReviewSort

export type StoreReviewSort = GeneratedStoreReviewSort

export const StoreReviewSort = {
  RECENT: StoreReviewSortSchema.enum.recent,
  HELPFUL: StoreReviewSortSchema.enum.helpful,
  HIGHEST: StoreReviewSortSchema.enum.highest,
  LOWEST: StoreReviewSortSchema.enum.lowest
} satisfies Record<string, GeneratedStoreReviewSort>

export const StoreReviewSortValues: readonly GeneratedStoreReviewSort[] = [
  StoreReviewSortSchema.enum.recent,
  StoreReviewSortSchema.enum.helpful,
  StoreReviewSortSchema.enum.highest,
  StoreReviewSortSchema.enum.lowest
]
